import CrudBaseService from "@/services/CrudBaseService";

export default class AcceptanceRuleService extends CrudBaseService {
  constructor() {
    super('insurance_pricing/acceptance_rules');
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  getRevision(id) {
    return this.http.get(`${this._serviceName}/${id}/revision`);
  }
}
